import UserService from '../../../services/user/UserService';

export default {
    data() {
        return {
            password: null,
            passwordConfirm: null
        }
    },
    computed: {
        isDisabled() {
            return !this.password || !this.passwordConfirm;
        }
    },
    async created () {
        await this.validateToken()
    },
    methods: {
        async validateToken() {
            try {
                const body = { token: this.$route.params.token }
                const response = await UserService.verifyRecoveryToken(body);
            } catch (error) {
                console.log(error)
                this.$buefy.toast.open({ message: 'El token ya expiró', type: 'is-danger', duration: 5000 })
                this.$router.push("/recover");
            }
        },
        async changePassword() {
            try {
                if (this.passwordConfirm !== this.password) {
                    this.$buefy.toast.open({ message: 'La contraseña no coincide', type: 'is-danger' })
                    return
                }
                if (!/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/.test(this.password)) {
                    this.$buefy.toast.open({ message: 'La contraseña debe contener al menos 8 caracteres, al menos una letra mayúscula, una letra minúscula y un número', type: 'is-danger' })
                    return
                }
                const body = {
                    password: this.password,
                    token: this.$route.params.token
                }
                const response = await UserService.passwordRecovery(body);
                this.$buefy.toast.open({ message: 'Se ha cambiado su contraseña', type: 'is-success', duration: 5000 })
                this.$router.push('/login')
            } catch (error) {
                console.log(error)
                this.$buefy.toast.open({ message: 'Hubo un problema. Intenta mas tarde', type: 'is-danger' })
            }
        }
    }
}